import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete';
import { Resizable } from "re-resizable";

const TextCard = ({item, updateInputText, addFocus, removeFocus, changeHeight, updateTextareaSize, removeItem}) => {
  let width = item.width && parseInt(item.width.substring(0, item.width.length - 2));
  let height = item.height && parseInt(item.height.substring(0, item.height.length - 2));


  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f0f0f0",
    transform: `rotate(${item.rotate_box})`,
  };
  

 const onResize = (e, direction, ref, d) =>{
  const data = {
    property_id:item.property_id,
    width: width + parseInt(d.width),
    height:height + parseInt(d.height),
  }

   updateTextareaSize(data);

  }
  return (
    <Resizable
    style={style}
    className="no-cursor"
    defaultSize={{
      width: item.width,
      height: item.height
  }}
    onResizeStop={onResize}
    
>
  <textarea 
    className='scroll handle'
    onChange={(event) => updateInputText(event, event.target.value)} 
    onFocus={()=>addFocus(item.property_id)} 
  
    style={{
    fontSize:item.font_size,
    lineHeight:item.line_height,
    fontFamily:item.font_family,
    fontWeight:item.font_weight,
    letterSpacing:item.letter_spacing,
    color:item.color,
    backgroundColor:item.background_color,
    textAlign:item.text_alignment,
    webkitTextStroke:item.text_stroke
    }}
    >
      {item.text_label}
    </textarea>
    <div className='rm-btn rm-2'><button type='button' onClick={() => removeItem(item.property_id)}><DeleteIcon/></button></div>
  
   
    </Resizable>
  )
}

export default TextCard